var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLpsCirclecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8143_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 5.34375C34.0337 5.34375 39.8202 7.78342 44.0867 12.1261C48.3531 16.4687 50.75 22.3586 50.75 28.5C50.75 34.6414 48.3531 40.5313 44.0867 44.8739C39.8202 49.2166 34.0337 51.6562 28 51.6562C21.9663 51.6562 16.1798 49.2166 11.9133 44.8739C7.64687 40.5313 5.25 34.6414 5.25 28.5C5.25 22.3586 7.64687 16.4687 11.9133 12.1261C16.1798 7.78342 21.9663 5.34375 28 5.34375ZM28 57C35.4261 57 42.548 53.9973 47.799 48.6525C53.05 43.3078 56 36.0587 56 28.5C56 20.9413 53.05 13.6922 47.799 8.34746C42.548 3.00267 35.4261 0 28 0C20.5739 0 13.452 3.00267 8.20101 8.34746C2.94999 13.6922 0 20.9413 0 28.5C0 36.0587 2.94999 43.3078 8.20101 48.6525C13.452 53.9973 20.5739 57 28 57ZM38.6203 21.4195L34.1688 18.5918C34.125 18.6586 31.4234 23.0561 26.0531 31.8064C23.8547 28.8229 22.3453 26.7744 21.525 25.6611L17.325 28.8674C17.7625 29.4574 20.0375 32.5523 24.15 38.1299L24.9375 39.1986H27.7047L28.4703 37.9406L37.2203 23.6906L38.6094 21.4195H38.6203Z",
    fill: "#288034"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8143_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpsCirclecheck);
export default __webpack_public_path__ + "static/media/lps-circlecheck.a2985d3170032e73ce4fb69f8ca8cd6f.svg";
export { ForwardRef as ReactComponent };